export const confirmAsync = (message: string) => {
  return new Promise((res, rej) => {
    // eslint-disable-next-line no-restricted-globals, no-alert
    const response = confirm(message);

    res(response);
  });
};
